<template>
  <div class="input-text">
    <div v-show="top" class="input-text__top">
      <label :for="name" class="label"><slot/></label>
      <div v-if="hint" class="hint">
        <Icon icon="hint" />
        <div class="hint__tooltip">
          <slot name="hint"></slot>
        </div>
      </div>
    </div>
    <input ref="input" :class="{ 'autofill' : hasAutofill }" :type="type" :id="name" :value="inputValue" :disabled="disabled" :placeholder="placeholder" :pattern="pattern" @keydown="resetAutofillStyle"/>
    <span v-if="hasAutofill" @click="resetAutofill" title="Wert zurücksetzen">autofill</span>
    <p class="error-msg">{{ errorMsg }}</p>
  </div>
</template>

// <InputText name="e-mail" type="email" value="lukas@gmx" :autofill="true" placeholder="E-Mail">
//   E-Mail
//   <p slot="hint">Hallo was geht</p>
// </inputText>

<script>
import Icon from '../../../components/Icon/Icon';

export default {
  name: 'InputText',
  components: {
    Icon,
  },
  data() {
    return {
      hasAutofill: this.autofill,
      inputValue: this.value,
    };
  },
  props: {
    name: String,
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    pattern: {
      type: String,
      default: null,
    },
    top: {
      type: Boolean,
      default: true,
    },
    errorMsg: {
      type: String,
      default: 'Falscher Wert. Bitte wiederholen Sie die Eingabe.',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: Boolean,
      default: false,
    },
    autofill: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    resetAutofillStyle() {
      this.hasAutofill = false;
    },
    resetAutofill() {
      this.resetAutofillStyle();
      this.inputValue = '';
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./InputText.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/formElements/InputText/InputText.vue